export default function CompanyIntro() {
  return (
    <section className="w-full bg-white py-16 px-4">
      <div className="max-w-5xl mx-auto flex flex-col lg:flex-row gap-12 items-center">
        {/* Image */}
        <div className="w-full lg:w-[420px] flex-shrink-0">
          <div className="w-full h-[300px] overflow-hidden border-l-4 border-[#1a73b5]">
            <img
              src="/images/17131727573736.jpg"
              alt="益維企業有限公司"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Text */}
        <div className="flex-1">
          {/* Section Title */}
          <p className="text-xs tracking-[0.35em] text-[#1a73b5] uppercase mb-2">COMPANY PROFILE</p>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-1 h-8 bg-[#1a73b5]" />
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 tracking-wider">公司簡介</h2>
          </div>

          <p className="text-gray-600 leading-[2] mb-4 text-sm md:text-base">
            益維企業有限公司（Electronics World Co., Ltd）成立於台灣台北，長期專注於歐美工業控制系統的代理與銷售，致力於為台灣各大製造業、石化、電力及工程產業提供高品質的工業自動化設備與解決方案。
          </p>
          <p className="text-gray-600 leading-[2] mb-4 text-sm md:text-base">
            多年來，益維與多家知名歐美品牌建立穩固的合作關係，代理產品涵蓋防爆設備、不銹鋼及 GRP 材質控制箱、接線箱、變壓器等工業電氣產品，能夠滿足各類嚴苛環境下的設備安裝需求。
          </p>
          <p className="text-gray-600 leading-[2] text-sm md:text-base">
            我們的服務團隊由一群擁有豐富工程背景的專業人員組成，不僅提供產品諮詢與選型建議，更能協助客戶進行現場規劃與技術支援，確保每一個項目都能順利落地執行。
          </p>

          {/* Stats */}
          <div className="flex gap-8 mt-8 pt-6 border-t border-gray-100">
            {[
              { num: '40+', label: '年產業經驗' },
              { num: '50+', label: '合作品牌' },
              { num: '1000+', label: '服務客戶' },
            ].map(s => (
              <div key={s.label} className="text-center">
                <div className="text-3xl font-bold text-[#1a73b5]">{s.num}</div>
                <div className="text-xs text-gray-500 mt-1 whitespace-nowrap">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
